"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndexFromText = void 0;
var lodash_1 = require("lodash");
function getIndexFromText(text) {
    return (0, lodash_1.range)(text.length).map(function (i) { return text.slice(0, i + 1).toLowerCase(); });
}
exports.getIndexFromText = getIndexFromText;
